{
  "metadata_main": {
    "title": "Jervice - Główna",
    "description": "Twój auto serwis"
  },
  "cart": {
    "title": "Koszyk",
    "confirm": "Złóż zamówienie",
    "empty": "Koszyk jest pusty",
    "added": "Usługa została dodana do koszyka",
    "or": "lub",
    "continue_shopping": "Kontynuuj zakupy"
  },
  "lang": {
    "en": "Angielski",
    "pl": "Polski"
  },
  "global": {
    "order_button_label": "Zamów serwis",
    "view_button_label": "Zobacz",
    "privacy_policy": "Polityka prywatności",
    "add_to_cart": "Dodaj do koszyka",
    "in_cart": "W koszyku",
    "marquee": {
      "tuning_discount": "Tuning {percent}% zniżki"
    },
    "not_found": {
      "title": "Nie znaleziono",
      "description": "Możliwe, że wpisałeś nieprawidłowy adres lub taka strona już nie istnieje.",
      "button_text": "Na stronę główną"
    },
    "menu": {
      "home": "Strona główna",
      "services": "Usługi",
      "contacts": "Kontakt"
    }
  },
  "hero": {
    "title": "Poznaj <1>nową jakość</1> obsługi samochodów!",
    "description": "JERVICE – rewolucja w obsłudze aut. Szybka obsługa z monitoringiem w Twoim telefonie, \ndla samochodów spalinowych jak i elektrycznych.",
    "cars_updated_label": "zawsze do Twojej dyspozycji",
    "quality_services_label": "boksów szybkiej obsługi",
    "banner_text_text": "Uzyskaj usługę wysokiej jakości w swoim mieście!"
  },
  "what_we_provide": {
    "title": "Co oferujemy?"
  },
  "mobile_app": {
    "title": "Odkryj naszą aplikację mobilną",
    "description": "zarezerwuj wizytę w kilka chwil, śledź aktualny status usługi\n na bieżąco i korzystaj ze specjalnych ofert oraz rabatów!"
  },
  "benefits": {
    "title": "Korzyści",
    "quality": {
      "title": "Jakość i niezawodność",
      "description": "Używamy tylko wysokiej jakości certyfikowanych \nmateriałów i profesjonalnego sprzętu do każdego typu usługi, wykonujemy powierzone nam zadania niezależnie od trudności i terminu realizacji."
    },
    "speed": {
      "title": "Szybkość",
      "description": "W Jervice dbamy o Twój czas i komfort, dlatego skupiamy się na zrealizowaniu zamówień w jak najkrótszym terminie, nie tracąc przy tym na jakości."
    },
    "range": {
      "title": "Nowoczesne rozwiązania",
      "description": "Używamy zautomatyzowanego systemu zleceń, który zapewnia każdemu klientowi perfekcyjną obsługę. Działamy zgodnie z ofertą, gdzie każda usługa ma wyznaczony czas realizacji. Jeśli wykonywany serwis Twojego samochodu zostanie opóźniony z naszej winy, otrzymasz wtedy 10% zniżki za każde dodatkowe 20 minut oczekiwania."
    }
  },
  "services": {
    "title": "Nasze usługi",
    "all_services": "Wszystkie usługi",
    "page_caption": "Cena za wykonanie usługi (nie licząc kosztów materiałów) jest zależna od specyfikacji i rodzaju pojazdu.",
    "all_service_button_text": "Pokaż wszystkie usługi",
    "back_to_services": "Powrót do listy",
    "sub_service_title": "Nazwa podusługi",
    "sub_service_caption": "Krótki opis",
    "sub_service_start_from": "od {{qty}}",
    "service_order": "Zamów",
    "empty_subservices": "Lista jest pusta",

    "tuning": {
      "title": "Tuning",
      "caption": "Poprawa wyglądu zewnętrznego pojazdów.",
      "description": "Oferujemy kompleksowe rozwiązania, w tym modernizacje silnika, ulepszenia zawieszenia i instalację wysokiej jakości sprzętu, aby Twój pojazd był mocniejszy i bardziej niezawodny."
    },
    "detailing": {
      "title": "Detailing",
      "caption": "Profesjonalne usługi detailingowe dla utrzymania nienagannego stanu wnętrza i nadwozia samochodu.",
      "description": "Nasze usługi detailingowe to kompleksowa opieka \nnad wyglądem Twojego samochodu –\nod profesjonalnego czyszczenia i polerowania \npo trwałe powłoki ochronne, które utrzymują\njego nienaganny wygląd przez długi czas."
    },
    "car_wash": {
      "title": "Myjnia",
      "caption": "Kompleksowe usługi mycia samochodów, aby Twój pojazd zawsze wyglądał jak najlepiej.",
      "description": "Stosujemy bezpieczne dla lakieru środki czyszczące  \noraz  nowoczesne techniki czyszczenia, które skutecznie \nusuwają nawet najtrudniejsze zabrudzenia.\nDzięki naszym usługom Twój samochód odzyska blask \ni będzie wyglądać jak nowy."
    },
    "sound_system": {
      "title": "System dźwiękowy",
      "caption": "Profesjonalna instalacja nowych systemów audio."
    },
    "battery_regeneration": {
      "title": "Regeneracja akumulatora",
      "caption": "Oferujemy usługi regeneracji akumulatorów w celu wydłużenia ich żywotności i optymalizacji działania."
    },
    "electrical_installation": {
      "title": "Instalacja elektryczna",
      "caption": "Profesjonalne usługi instalacji elektrycznych dla pojazdów elektrycznych i tradycyjnych."
    },
    "sound_proofing": {
      "title": "Wyciszenie",
      "caption": "Profesjonalna instalacja nowych systemów audio.",
      "description": "Oferujemy profesjonalne usługi wyciszenia samochodu,\nktóre znacząco redukują hałas wewnątrz pojazdu.\nDzięki naszym rozwiązaniom zostaną zredukowane szumy drogowe, podróż staje się cichsza,\nbardziej komfortowa i przyjemna. Stosujemy wysokiej \njakości materiały wygłuszające, dostosowane do potrzeb\nTwojego auta."
    },
    "computer_diagnostic": {
      "title": "Diagnostyka komputerowa",
      "caption": "Wykorzystanie zaawansowanej diagnostyki komputerowej do identyfikacji i rozwiązywania problemów z pojazdem."
    }
  },
  "contacts": {
    "title": "Znajdź nas na mapie",
    "contacts_title": "Skontaktuj się z nami",
    "socials_title": "Śledź nas w mediach społecznościowych"
  },
  "privacy_policy": {
    "title": "Polityka prywatności",
    "general": {
      "title": "Postanowienia ogólne",
      "caption": "Szanujemy Twoją prywatność i zobowiązujemy się do ochrony Twoich danych osobowych. Niniejsza polityka prywatności opisuje, jak gromadzimy, wykorzystujemy, przechowujemy i chronimy Twoje informacje."
    },
    "data_collection": {
      "title": "Zbieranie danych",
      "caption": "Możemy zbierać następujące informacje:",
      "list": {
        "item_0": "Twoje imię i dane kontaktowe (telefon, e-mail).",
        "item_1": "Informacje o Twoim pojeździe (marka, model, numer rejestracyjny).",
        "item_2": "Historia serwisowania i zapytania."
      }
    },
    "personal_data": {
      "title": "Wykorzystanie danych osobowych",
      "caption": "Zebrane dane są wykorzystywane do:",
      "list": {
        "item_0": "Planowania i zarządzania wizytami serwisowymi.",
        "item_1": "Potwierdzania i realizacji zamówień.",
        "item_2": "Poprawy jakości naszych usług."
      }
    },
    "data_sharing": {
      "title": "Udostępnianie danych",
      "caption": "Nie udostępniamy Twoich danych osobowych osobom trzecim, chyba że jest to wymagane przez prawo."
    },
    "data_retention": {
      "title": "Przechowywanie danych",
      "caption": "Twoje dane są przechowywane na bezpiecznych serwerach. Podejmujemy wszelkie środki, aby zapobiec nieautoryzowanemu dostępowi lub utracie danych."
    },
    "your_rights": {
      "title": "Twoje prawa",
      "caption": "Masz prawo do:",
      "list": {
        "item_0": "Żądania dostępu do swoich danych osobowych.",
        "item_1": "Żądania poprawienia lub usunięcia swoich danych."
      }
    },
    "contact_us": {
      "title": "Skontaktuj się z nami",
      "caption": "W przypadku pytań prosimy o kontakt:",
      "email": "Email: {{email}}",
      "phone": "Telefon: {{phone}}"
    },
    "back_button_text": "Powrót na stronę główną"
  },
  "order_service": {
    "info_caption": "Wypełnij dane osobowe i dane pojazdu",
    "info_title": "<wrapper>Rezerwacja</wrapper> serwisu samochodowego",
    "full_name": "Imię i nazwisko",
    "vehicle_brand": "Marka pojazdu",
    "phone_number": "Numer telefonu",
    "vehicle_model": "Model pojazdu",
    "email": "Email",
    "year": "Rok",
    "license": "Tablica rejestracyjna",
    "company_order": "Zamówienie firmowe",
    "select_service": "Wybierz usługę",
    "service_caption": "Określ swój wybór",
    "service_title": "<wrapper>Wybierz</wrapper> usługę i datę",
    "time_slots": "Przedziały czasowe",
    "service_type": "Rodzaj usługi",
    "service": "Usługa",
    "add_service": "Dodaj usługę",
    "service_description": "Jeśli chcesz umówić się na inny dzień na dodatkową usługę, utwórz nowe zamówienie.",
    "checkout": "Przejdź do płatności",
    "success": "Sukces!",
    "success_text": "Nasz operator skontaktuje się z Tobą w ciągu 1 godziny.",
    "back_home": "Powrót do strony głównej",
    "select_country": "Wybierz kraj",
    "select_time": "Wybierz czas",
    "last_step": "Ostatni krok",
    "checkout_title": "Zamówienie",
    "service_list": "Lista usług",
    "total": "Razem",
    "confirm": "Potwierdź",
    "cancel": "Anuluj",
    "no_services": "Lista usług jest pusta",
    "success_add": "Pomyślnie dodano do zamówienia!"
  },
  "cookies": {
    "title": "Używamy plików cookie",
    "description": "Używamy plików cookie oraz podobnych technologii, aby poprawić Twoje doświadczenie na naszej stronie, analizować ruch i personalizować treści. Klikając „Akceptuj wszystkie”, zgadzasz się na użycie wszystkich plików cookie.",
    "settings": "Ustawienia plików cookie",
    "necessary_title": "Niezbędne pliki cookie (zawsze aktywne)",
    "necessary_description": "Te pliki cookie są wymagane do podstawowego działania strony.",
    "analytics_title": "Analityczne pliki cookie",
    "analytics_description": "Pomagają nam zrozumieć, w jaki sposób użytkownicy korzystają ze strony (Google Analytics).",
    "marketing_title": "Marketingowe pliki cookie",
    "marketing_description": "Służą do wyświetlania dopasowanych reklam i śledzenia skuteczności kampanii.",
    "accept_all": "Akceptuj wszystkie",
    "only_necessary": "Tylko niezbędne",
    "save_settings": "Zapisz ustawienia"
  },
  "order": {
    "form_title": "Finalizacja zamówienia",
    "services_title": "Usługi",
    "submit_button": "Potwierdź",
    "required_info": "Informacje kontaktowe",
    "optional_info": "Dodatkowe informacje",
    "choose_date": "Wybierz datę i godzinę",
    "time_slots": "Przedziały czasowe",
    "not_available": "Brak wolnych godzin do rezerwacji",
    "confirm": "Potwierdź",
    "cancel": "Anuluj",
    "success": "Sukces!",
    "success_text": "Nasz operator skontaktuje się z Tobą w ciągu 1 godziny.",
    "total": "Razem",
    "not_specified": "Nie określono",
    "add_service": "Dodaj usługę",
    "checkout_title": "Zamówienie",
    "service_list": "Lista usług",
    "service_type": "Rodzaj usługi",
    "select_service": "Wybierz usługę",
    "checkout": "Przejdź do płatności",
    "available_time": "Dostępny czas",
    "pre_order_caption": "Dokonujesz rezerwacji wstępnej.\nNasz menedżer skontaktuje się z Tobą w celu potwierdzenia terminu.",
    "invoice": {
      "title": "Zamówienie nr {{order}}",
      "client": "Klient",
      "car": "Samochód",
      "services": "Usługi"
    },
    "placeholders": {
      "name": "Imię i nazwisko",
      "phone": "Numer telefonu",
      "email": "Email",
      "brand": "Marka samochodu",
      "model": "Model samochodu",
      "year": "Rok produkcji",
      "license": "Tablica rejestracyjna",
      "company_order": "Zamówienie firmowe"
    }
  }
}
